module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 041.7278fbc4.jpg";